module.exports = __webpack_public_path__ + "static/media/Association Success Logo.c77e25ef.JPG";